import React, { useMemo, useRef } from 'react';
import { useClassNames } from 'hooks/useClassNames';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import { PDropdownStyle as S } from './PDropdown.style';
import { Icon } from 'components/Icon/Icon';
import { Box } from 'components/layouts/primitives/Box/Box';

export type PDropdownPropsSeverity = 'filled' | 'outlined';

export const PDropdown = React.forwardRef<
  Dropdown,
  Omit<DropdownProps, 'size'> & {
    invalid?: boolean;
    type?: 'primary' | 'inline' | 'combo';
    headerItemsNoPadding?: boolean;
    size?: 'small' | 'large' | 'default';
    severity?: PDropdownPropsSeverity;
    fixedWidth?: boolean;
    containerClassName?: string;
  }
>((props, ref) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const cleanProps = useMemo(
    () =>
      (({ invalid, panelClassName, size, fixedWidth, containerClassName, headerItemsNoPadding, ...o }: any) =>
        o)(props),
    [props]
  );
  const containerClassNames = useClassNames(
    {
      'fit-content': props.type === 'inline',
    },
    props.containerClassName
  );
  const classNames = useClassNames(
    {
      'p-invalid': props.invalid,
      'p-dropdown-sm': props.size === 'small',
      'p-dropdown-lg': props.size === 'large',
      [`p-dropdown-type-${props.type || 'primary'}`]: true,
      [`p-dropdown-${props.severity || 'outlined'}`]: true,
    },
    props.className
  );
  const panelClassName = useClassNames(
    { 'header-items-no-padding': props.headerItemsNoPadding, 'fixed-width': props.fixedWidth },
    props.panelClassName
  );

  return (
    <S.Container className={containerClassNames}>
      <S.Dropdown
        editable={props.type === 'combo'}
        showClear={props.type === 'combo'}
        {...cleanProps}
        onHide={() => {
          (document?.activeElement as any)?.blur();
        }}
        inputRef={inputRef}
        panelClassName={panelClassName}
        className={classNames}
        dropdownIcon={<Icon icon="chevronDownLine" />}
        collapseIcon={<Icon icon="chevronDownLine" />}
        clearIcon={
          <Box onClick={(e) => props.onChange?.({ ...e, value: null } as any)}>
            <Icon icon="xCircleSolid" className="p-dropdown-clear-icon" />
          </Box>
        }
        ref={ref}
      />
      <Icon icon="alertCircleSolid" className="p-dropdown-invalid-icon" />
    </S.Container>
  );
});
